
export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-thin text-gray-900 mb-6">
              About LACOJEC LTDA
            </h2>
            <div className="w-20 h-1 bg-teal-500 mb-8"></div>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              LACOJEC LTDA is a leading technology company specializing in developing innovative applications that enhance digital security and user experience. Based in Barranquilla, Colombia, we are committed to providing cutting-edge solutions for modern internet users.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our flagship VPN application represents our dedication to protecting user privacy and ensuring secure, unrestricted access to the internet. We combine advanced encryption technology with user-friendly design to deliver a superior VPN experience.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              At LACOJEC LTDA, we believe in transparency, security, and innovation. Our team works tirelessly to maintain the highest standards of data protection while continuously improving our services to meet the evolving needs of our users.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/bc7bed1d7e75c589079eb23851338a0b.jpg"
              alt="LACOJEC LTDA Office"
              className="w-full h-auto rounded-lg shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
